export * from './cuenta-autocomplete.component';


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/autocomplete/cuenta-autocomplete/index.ts